import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"; //CardImg,
import { CardBody } from "reactstrap";
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";


class TankList extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
	  customerCode: "",
      modal: false,
      viewqrcodepopup: "",
      qrpath: "",
      tankData: []
    };
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() {
	if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User"|| this.props.userRole === "Marketing"  || this.props.userRole =='CRE' || this.props.userRole =='Logistics' || this.props.userRole =='Project Engineer') {
      const url = process.env.REACT_APP_NODE_ENV + "/api/iot/gettank";
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          return response.json();
        }
      ).then(data => {
        this.setState({ tankData: data })
      })
	  
	}else{			
		const url = process.env.REACT_APP_NODE_ENV + "/api/iot/getTankByUserId/" + this.props.userId;
		  fetch(url, {
			method: 'GET',
			headers: {
			  'Content-Type': 'application/json',
			  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			}
		  }).then(
			response => {
			  return response.json();
			}
		  ).then(data => {
			this.setState({ tankData: data })
		})
		  
	}
  }

  viewQRCode = value => {
      //alert(value)
     this.setState({ viewqrcodepopup: true, qrpath:"http://gowatr.com/qrcode/images/"+value+'.png' });
  };

  closeQRpopup = () => {
    this.setState({ viewqrcodepopup: false, qrpath:"" });
 };
  
  getApartmentID = (userId) => {
    const url = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/getApartmentIdByUser/" + userId;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => { return response.json(); }
    ).then(data =>  {
		
		if(data.length != 0) 
		{
			this.setState({ customerCode: data[0].apartmentId })
		}
		else {
		   this.setState({ customerCode: "" }) 
		}
	})
  }


  render() {

    let dataArr = [];
    this.state.tankData.map((data) => {
		
		var custype = data.customerType
		if(custype === 'Corporate_Customer'){
			custype = "Corporate Customer"
		}else if(custype === 'Apartment_Customer'){
			custype = "Apartment Customer"
		}else if(custype === 'Individual_Customer'){
			custype = "Individual Customer"
		}
	
      let mdData = [
        data.id, data.customerName, custype, data.customerCode, data.tankType, data
      ];
      dataArr.push(mdData)
      return null;
    });
	
	const mystyle = {
	  marginRight: "5px"
    };

    const columns = [
      {
        name: "Id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "customerName",
        label: "Customer Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "customerType",
        label: "Customer Type",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "customerCode",
        label: "Customer Id",
        options: {
          filter: true,
          sort: true,
        }
      },	  
      {
        name: "Tank Type",
        label: "tankType",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
				{ value.deviceId ? <Button variant="outline-success" onClick={() => this.nextPath("/water-tank/tank-view", value.id)} style={mystyle} > View Tank </Button> : ""}
				 {value.flowMeterdeviceId ? <Button variant="outline-success" onClick={() => this.nextPath("/water-tank/tank-flow-view", value.id)} style={mystyle} > Flow  Meter</Button> : ""}
         {value.flowMeterdeviceId ? <Button variant="outline-success" onClick={() => this.viewQRCode(value.customerCode+"_"+value.flowMeterdeviceId)} style={mystyle} > QR Code</Button> : ""}
				<Button variant="outline-success" onClick={() => this.nextPath("/water-tank/tank-edit", value.id)} style={mystyle}> Edit </Button>
              </>
            );
          }
        }
      }
    ];

	const columns1 = [
      {
        name: "Id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "customerType",
        label: "Customer Type",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "customerCode",
        label: "Customer Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Tank Type",
        label: "tankType",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Tank Type",
        label: "tankType",
        options: {
          filter: true,
          sort: true,
		  display: false
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
			  console.log(value)
            return (
              <>
			  {value.deviceId ? <Button variant="outline-success" onClick={() => this.nextPath("/water-tank/tank-view", value.id)} style={mystyle} > View Tank </Button> : ""}
			  {value.flowMeterdeviceId ? <Button variant="outline-success" onClick={() => this.nextPath("/water-tank/tank-flow-view", value.id)} style={mystyle} > Flow Meter </Button>  : ""}
        <Button variant="outline-success" onClick={() => this.viewQRCode(value)} style={mystyle} > QR Code</Button>
              </>
            );
          }
        }
      }
    ];

    const options = {
      filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none", viewColumns: false,
      downloadOptions: {
        filename: 'Apartment Customer List.csv',
      },
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

    let viewqrcodepopup = null;
    if (this.state.viewqrcodepopup) {
      viewqrcodepopup = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>              
              <ModalBody>
              <div className="col-lg-12">
                <img src={this.state.qrpath} onError={(e)=>{e.target.onerror = null; e.target.src="http://gowatr.com/qrcode/images/blocked.png"}} class="d-block mx-auto img-fluid" alt="profile Image" width="80%" />
              </div>
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.closeQRpopup()}> Ok </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User"  || this.props.userRole =='CRE') {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>Tank</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}>
            <Button className="float-right"
              variant="outline-success"
              style={{ marginTop: "10px", marginRight: "10px", width: "200px" }}
              onClick={() => this.nextPath("/water-tank/tank-create", "")
              }>
              Create Tank
                    </Button>
            <MUIDataTable
              title={"Tank List"}
              data={dataArr}
              columns={columns}
              options={options} />
              {viewqrcodepopup}
          </div>
        </>
      );
    } else {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>Tank</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}>
            <MUIDataTable
              title={"Tank List"}
              data={dataArr}
              columns={columns1}
              options={options} />
              {viewqrcodepopup}
        
          </div>
        </>
      );
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(TankList)
